export default [
    'Unconscious incompetence',
    'Conscious incompetence',
    "Conscious competence",
    'Unconscious competence',
]